import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataOperationEvent } from '@rapider/ai-chat';
import { ProjectModelDataViewerComponent } from '../project-model-data-viewer/project-model-data-viewer.component';
import { ProjectModelSpreadsheetViewerComponent } from '../project-model-spreadsheet-viewer/project-model-spreadsheet-viewer.component';
import { DATA_INSIGHT_CONFIG } from '../database.config';

/**
 * @class DataInsightComponent
 * @description A wrapper component that displays information about a specific data operation event
 * and utilizes the ProjectModelDataViewerComponent to render the affected data and its relations.
 */
@Component({
  selector: 'rapider-data-insight',
  standalone: true,
  imports: [
    CommonModule,
    ProjectModelDataViewerComponent,
    ProjectModelSpreadsheetViewerComponent,
  ],
  templateUrl: './data-insight.component.html',
})
export class DataInsightComponent {
  @Input({ required: true }) event!: DataOperationEvent;
  @Input({ required: false }) showEventDescription? = false;
  /**
   * Toggle to switch between the new editable spreadsheet viewer and the standard list-grid viewer.
   * Defaults to true to prioritize the enhanced spreadsheet experience.
   */
  @Input() displayWithSpreadsheet: boolean = true;
  public readonly config = DATA_INSIGHT_CONFIG;
}

//   /**
//    * Accumulates all historical record IDs for this model, injecting the current event's IDs at the top.
//    * This guarantees that the user sees an aggregated grid of all interacted items, ordered newest to oldest.
//    */
//   public accumulatedRecordIds = computed(() => {
//     const currentEvent = this.event;
//     if (!currentEvent) return [];

//     const allEvents = this.store.selectSignal(selectEvents)();

//     // Find all historical events matching this model name and extract their record IDs
//     const historyIds = allEvents
//       .filter(e => e.projectModelName === currentEvent.projectModelName)
//       .flatMap(e => e.recordIds || []);

//     // Merge: Current event's IDs take priority at the front, followed by history
//     const combined = [...(currentEvent.recordIds || []), ...historyIds];

//     // Deduplicate while preserving the "newest first" order
//     return Array.from(new Set(combined));
//   });
// }
